module.exports = __webpack_public_path__ + "static/media/telegram.7b8caa18.png";